import {LangKeyType} from '../../provider/locale/translation/type';

import {ReviewSortingTypeEnum} from './reviews-type';

export const REVIEW_SORT_OPTIONS: Array<ReviewSortingTypeEnum> = [
    ReviewSortingTypeEnum.acs,
    ReviewSortingTypeEnum.desc,
    ReviewSortingTypeEnum.ratingAsc,
    ReviewSortingTypeEnum.ratingDesc,
];

export function isRatingSort(sort: ReviewSortingTypeEnum): boolean {
    return sort === ReviewSortingTypeEnum.ratingDesc || sort === ReviewSortingTypeEnum.ratingAsc;
}

const reviewSortOptionLabelKeyMap: Record<ReviewSortingTypeEnum, LangKeyType> = {
    [ReviewSortingTypeEnum.acs]: 'REVIEWS__SORT__NEWEST',
    [ReviewSortingTypeEnum.desc]: 'REVIEWS__SORT__OLDEST',
    [ReviewSortingTypeEnum.ratingAsc]: 'REVIEWS__SORT__RATING_ASC',
    [ReviewSortingTypeEnum.ratingDesc]: 'REVIEWS__SORT__RATING_DESC',
};

export function getReviewSortOptionLabelKey(sort: ReviewSortingTypeEnum): LangKeyType {
    return reviewSortOptionLabelKeyMap[sort];
}

export function getApiOrderingForSort(sort: ReviewSortingTypeEnum): string {
    if (isRatingSort(sort)) {
        return ReviewSortingTypeEnum.acs;
    }

    return sort;
}
